<template>
    <b-card class="mt-3">
        <p class="text-bold">{{trans('community.add_your_post')}}</p>
        <b-form @submit.stop.prevent="submitPost">
            <b-form-group
                :label="trans('community.title')"
                label-for="title"
            >
                <b-form-textarea
                        id="title"
                        v-model="formData.title"
                        :placeholder="trans('example_post_title')"
                        rows="2"
                        max-rows="6"
                        required
                ></b-form-textarea>
            </b-form-group>

            <b-form-group
                :label="trans('community.description')"
                label-for="title"
            >
                <b-form-textarea
                        id="description"
                        v-model="formData.description"
                        :placeholder="trans('community.post_description')"
                        rows="3"
                        max-rows="6"
                ></b-form-textarea>
            </b-form-group>


            <div class="d-flex justify-content-end">
                <b-button type="submit" variant="lbv" v-bind:class="this.loading ? 'disabled' : ''">{{trans('community.publish')}}</b-button>
            </div>
        </b-form>
    </b-card>
</template>

<script>
    export default {
        name: "AddPostCard",
        props:{
            moduleId: Number,
            callback: Function
        },
        data(){
          return {
              formData: {
                  title: '',
                  description: ''
              },
              loading: false
          }
        },
        methods:{
            submitPost(){
                const data = {...this.formData, module_id: this.moduleId};
                this.loading = true;

                this.$axios.post('/add-post/save', data)
                    .then((res)=>{
                        if(this.callback !== undefined){
                            this.callback();
                        }
                    })
                    .catch((e)=>{
                        console.log(e);
                    })
            }
        }
    }
</script>
